import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=Artistic%20editorial%20still%20life%20of%20premium%20fashion%20products%2C%20sneakers%2C%20a%20folded%20sweater%20and%20a%20leather%20bag%20arranged%20on%20a%20soft%20warm%20cream%20background%20with%20sage%20green%20and%20terracotta%20accents%2C%20gentle%20natural%20light%2C%20minimalist%20high%20end%20aesthetic%2C%20wide%20banner%20composition&width=1600&height=900&seq=hero-main-2&orientation=landscape&nocache=true";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src={HERO_IMAGE}
        alt="Basetao Spreadsheet products"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 pb-16 text-center">
        <div className="mx-auto w-full max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs md:text-sm font-medium text-background-50 backdrop-blur whitespace-nowrap">
            <i className="ri-sparkling-2-line"></i>
            {t("hero.eyebrow")}
          </span>

          <h1 className="mt-6 text-3xl md:text-5xl font-heading font-semibold text-background-50 leading-tight">
            {t("hero.h1")}
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-100/90 leading-relaxed">
            {t("hero.desc")}
          </p>

          <p className="mt-3 text-sm md:text-base text-background-200/85 leading-relaxed">
            {t("hero.secondary")}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              {t("button.basetaoSpreadsheet")}
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-colors"
            >
              {t("button.buyNow")}
              <i className="ri-shopping-bag-3-line text-base"></i>
            </a>
            <Link
              to="/basetao-legit"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/50 px-6 py-3 text-sm md:text-base font-semibold text-background-50 whitespace-nowrap cursor-pointer hover:bg-background-50/15 transition-colors"
            >
              {t("button.readGuide")}
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          <p className="mt-8 text-xs md:text-sm text-background-200/80">
            {t("hero.trust")}
          </p>
        </div>
      </div>
    </section>
  );
}